import React from 'react'
import OrderDetailListingHeader from './OrderDetailListingHeader/OrderDetailListingHeader'
import OrderDetailTabsData from './OrderDetailTabsData/OrderDetailTabsData'

const OrderDetail = () => {
    return (
        <>
            <div className="card-box p-t-30">
                <OrderDetailListingHeader />
                <OrderDetailTabsData />
            </div>
        </>
    )
}

export default OrderDetail